// resources/scripts/modules/fullWidthVideo.js

export default function fullWidthVideo() {
  const videoBlocks = document.querySelectorAll('.full-width-video .video-wrapper');
  if (!videoBlocks.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const wrapper = entry.target;
      const iframe = wrapper.querySelector('iframe');
      const video = wrapper.querySelector('video');

      if (!entry.isIntersecting) {
        // Pause & reset to thumbnail
        if (iframe && iframe.contentWindow) {
          const src = iframe.getAttribute('src');
          if (src.includes('youtube')) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (src.includes('vimeo')) {
            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
        if (video && !video.paused) video.pause();

        wrapper.classList.remove('is-playing');
      }
    });
  }, { threshold: 0.2 });

  videoBlocks.forEach((wrapper) => {
    observer.observe(wrapper);

    const playBtn = wrapper.querySelector('.video-play-btn');
    if (!playBtn) return;

    playBtn.addEventListener('click', () => {
      wrapper.classList.add('is-playing');
      const iframe = wrapper.querySelector('iframe');
      const video = wrapper.querySelector('video');

      // Autoplay logic
      if (iframe) {
        const src = iframe.getAttribute('src');
        if (!src.includes('autoplay=1')) {
          iframe.setAttribute('src', `${src}${src.includes('?') ? '&' : '?'}autoplay=1`);
        } else {
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
      }

      if (video) video.play();
    });
  });
}
